import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { EIDs, EStoryType } from '../common/enums';
import { useDynamicTranslations } from '../common/hooks/useTranslations';

const SurveyFormRadioButtons = ({ onRadioChange, radioValue, lng }) => {
  const myselfLabel = useDynamicTranslations('myself', lng);
  const interviewLabel = useDynamicTranslations('interview', lng);
  const otherLabel = useDynamicTranslations('other', lng);

  return (
    <RadioGroup value={radioValue} onChange={onRadioChange}>
      <FormControlLabel
        value={EStoryType.MYSELF}
        control={<Radio />}
        label={myselfLabel}
      />
      <FormControlLabel
        value={EStoryType.INTERVIEW}
        control={<Radio />}
        label={interviewLabel}
      />
      <FormControlLabel
        value={EStoryType.OTHER}
        control={<Radio />}
        label={otherLabel}
      />
    </RadioGroup>
  );
};

export default SurveyFormRadioButtons;
